import { useRequestHeaders } from 'nuxt/app'
import { defineStore } from 'pinia'

export const useDesktopStore = defineStore('desktop', () => {
  const isDesktop = ref(false)

  if (process.server) {
    const headers = useRequestHeaders()
    const uaDevice = headers['x-ua-device']
    isDesktop.value = uaDevice
      ? uaDevice === 'desktop'
      : !headers['user-agent']?.includes('Mobile')
  }
  if (process.client) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- window.isDesktop added by desktop app
    isDesktop.value =
      window.isDesktop || !navigator.userAgent.includes('Mobile')
  }
  return { isDesktop }
})
